var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7585 4.82774L2.43753 22.1874L1 25L3.81193 23.5625L21.1723 6.24151L19.7585 4.82774ZM23.2936 1.29267L21.8798 2.70644L23.2936 4.12085L24.7073 2.70644C24.8947 2.51892 25 2.26466 25 1.99956C25 1.73445 24.8947 1.48019 24.7073 1.29267C24.5198 1.10527 24.2656 1 24.0004 1C23.7353 1 23.4811 1.10527 23.2936 1.29267Z",
    fill: "#454545",
    stroke: "#454545",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.77988447670c3a8d425d8a2b8f96ada4.svg";
export { ForwardRef as ReactComponent };